export const CHECKOUT_URL =
  'https://farmacologia-para-estudiantes-de-enfermeria.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/qpFf2on5iEX2W1aTMihwZQ/Mega_pack_de_farmacologia_para_enfermeria.png'

export const PRODUCT_NAME = 'MEGA PACK FARMACOLOGÍA PARA ESTUDIANTES DE ENFERMERÍA'

export const PRICE = '$19.990'

/* 1. PROBLEMA */
export const problems = [
  {
    icon: 'layers' as const,
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Tenés un tema en un PDF, otro en un apunte y una explicación guardada en el celular. Encontrar y conectar todo se vuelve una tarea más.',
  },
  {
    icon: 'help' as const,
    title: 'NO SABÉS QUÉ APRENDER PRIMERO',
    desc: 'Farmacocinética, receptores, antibacterianos, diuréticos, concentraciones… Hay tantos conceptos que cuesta organizar el comienzo.',
  },
  {
    icon: 'route' as const,
    title: 'TE FALTA UNA RUTA',
    desc: 'Querés comprender los medicamentos, pero necesitás un recorrido que conecte los fundamentos con las familias, las fichas y los ejercicios.',
  },
  {
    icon: 'repeat' as const,
    title: 'SEGUÍS RELEYENDO SIN COMPROBAR',
    desc: 'Pasás tiempo frente a los apuntes, pero cuando intentás responder una pregunta no sabés si realmente comprendiste el tema.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    icon: 'book' as const,
    title: 'FUNDAMENTOS DE FARMACOLOGÍA DESDE CERO',
    desc: 'Comprendé principio activo, presentaciones, vías, absorción, distribución, metabolismo, eliminación y mecanismos de acción. Construí una base para avanzar con más orden.',
  },
  {
    icon: 'pill' as const,
    title: 'GRUPOS FARMACOLÓGICOS: COMPRENDER Y COMPARAR',
    desc: 'Relacioná analgésicos, antimicrobianos, cardiovasculares, diuréticos, antidiabéticos y otros grupos. Diferenciá mecanismos, efectos y precauciones sin estudiar solamente nombres aislados.',
  },
  {
    icon: 'clipboard' as const,
    title: 'FICHAS FARMACOLÓGICAS Y CUIDADOS DE ENFERMERÍA',
    desc: 'Aprendé a organizar información sobre medicamentos, interpretar fichas y reconocer datos que necesitan verificación. Conectá los conceptos con observación, registro y comunicación.',
  },
  {
    icon: 'calculator' as const,
    title: 'CÁLCULO DE MEDICACIÓN Y ANÁLISIS DE RESULTADOS',
    desc: 'Practicá conversiones, concentraciones, volúmenes, velocidades y tiempos mediante ejercicios ficticios resueltos. Comprendé cada operación y comprobá las unidades.',
  },
  {
    icon: 'shield' as const,
    title: 'SEGURIDAD EN EL PROCESO DE MEDICACIÓN',
    desc: 'Estudiá identificación, indicaciones incompletas, alergias, rotulado, conservación y registro. Reconocé situaciones en las que corresponde detenerse, verificar y consultar.',
  },
  {
    icon: 'cap' as const,
    title: 'CASOS INTEGRADORES Y PREPARACIÓN DE EXÁMENES',
    desc: 'Uní los contenidos con situaciones académicas, preguntas y cálculos. Revisá respuestas explicadas y detectá qué temas necesitás reforzar.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    icon: 'cards' as const,
    title: 'TARJETAS DE REPASO DE FARMACOLOGÍA',
    desc: 'Preguntas y respuestas sobre fundamentos, mecanismos, familias, cálculos y seguridad. Practicá responder antes de mirar la solución.',
  },
  {
    icon: 'map' as const,
    title: 'MAPAS MENTALES Y CUADROS COMPARATIVOS',
    desc: 'Esquemas para conectar conceptos, visualizar procesos y distinguir grupos que suelen confundirse. Incluye actividades para construir tus propios mapas.',
  },
  {
    icon: 'calculator' as const,
    title: 'CUADERNO EXTRA DE CÁLCULOS RESUELTOS',
    desc: 'Ejercicios ficticios de unidades, concentraciones, volúmenes y tiempos. Resoluciones paso a paso, comprobaciones y detección de errores frecuentes.',
  },
  {
    icon: 'calendar' as const,
    title: 'ORGANIZADOR DE ESTUDIO Y PLANTILLAS DE FICHAS',
    desc: 'Planificadores, seguimiento por tomo, registro de dudas y cuaderno de errores. Plantillas para preparar fichas con fuentes y fechas.',
  },
  {
    icon: 'check' as const,
    title: 'AUTOEVALUACIONES POR UNIDAD',
    desc: 'Preguntas, casos y ejercicios con respuestas explicadas. Comprobá lo aprendido y organizá el repaso según tus dificultades.',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: 'compass' as const,
    title: 'MENOS CONFUSIÓN',
    desc: 'Seguí un recorrido desde los conceptos básicos hasta las familias, las fichas y los casos integradores.',
  },
  {
    icon: 'pencil' as const,
    title: 'MÁS PRÁCTICA DE ESTUDIO',
    desc: 'Combiná lectura con preguntas, comparaciones y ejercicios. Comprobá qué podés explicar sin consultar.',
  },
  {
    icon: 'bulb' as const,
    title: 'COMPRENDÉ LO QUE ESTÁS LEYENDO',
    desc: 'Relacioná el mecanismo de un grupo con sus efectos y reconocé las particularidades que necesitan verificación.',
  },
  {
    icon: 'target' as const,
    title: 'UN REPASO CON DIRECCIÓN',
    desc: 'Identificá errores, registrá dudas y volvé al tema que necesitás trabajar antes de avanzar.',
  },
]

/* 5. LO QUE VAS A PODER PRACTICAR */
export const practiceGoals = [
  'Explicar con mis palabras las diferencias entre farmacocinética y farmacodinamia',
  'Comparar familias sin asumir que todos sus integrantes tienen los mismos riesgos',
  'Resolver un ejercicio y comprobar que las unidades sean correctas',
  'Reconocer cuándo falta información y qué necesito consultar',
  'Organizar el repaso según mis errores y dudas',
]

/* 6. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Estoy en segundo año y farmacología era la materia que más me angustiaba. Tenía apuntes de tres profesores distintos y capturas por todos lados. Con el tomo de fundamentos entendí por fin la diferencia entre farmacocinética y farmacodinamia, y los mapas comparativos me ayudaron a dejar de mezclar los grupos. Llegué al parcial sabiendo qué había estudiado y qué me faltaba.',
    author: 'Camila Benítez',
    role: 'Estudiante de enfermería, 2.º año, 21 años',
    location: 'Córdoba, Argentina',
  },
  {
    quote:
      'Trabajo de administrativa durante el día y curso enfermería a la noche, así que el tiempo de estudio es muy poco. El organizador y las tarjetas de repaso me permitieron aprovechar los viajes en colectivo. Ahora repaso 20 minutos por día con preguntas en vez de releer páginas enteras, y siento que lo que estudio me queda.',
    author: 'Romina Aguirre',
    role: 'Estudiante de enfermería que trabaja, 34 años',
    location: 'Rosario, Argentina',
  },
  {
    quote:
      'Los cálculos eran mi punto débil: me trababa con las conversiones y nunca sabía si el resultado tenía sentido. El cuaderno de cálculos resueltos explica cada paso y enseña a comprobar las unidades. Hice todos los ejercicios dos veces y en la evaluación de cálculo pude resolver todo con calma.',
    author: 'Tomás Villalba',
    role: 'Estudiante de enfermería, 1.er año, 19 años',
    location: 'Mendoza, Argentina',
  },
  {
    quote:
      'Retomé la carrera después de diez años y sentía que todos sabían más que yo. Empezar desde cero con el primer tomo me devolvió la confianza. Las fichas farmacológicas me enseñaron a ordenar la información de cada medicamento y a reconocer qué datos tengo que verificar antes de dar por sentado algo.',
    author: 'Lorena Castillo',
    role: 'Estudiante de enfermería que retomó la carrera, 39 años',
    location: 'San Miguel de Tucumán, Argentina',
  },
  {
    quote:
      'Me estaba preparando para el final y no sabía por dónde empezar a repasar. Los casos integradores y las autoevaluaciones me mostraron exactamente qué temas tenía flojos. Armé el cuaderno de errores que propone el organizador y volví solo a lo que necesitaba. Fue la primera vez que estudié con un plan.',
    author: 'Agustina Paredes',
    role: 'Estudiante de enfermería, 3.er año, 24 años',
    location: 'La Plata, Argentina',
  },
]

/* 7. FAQ */
export const faqs = [
  {
    q: '¿Es físico o digital?',
    a: 'Es un producto 100% digital en PDF. No se envían libros físicos.',
  },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'Comienza con conceptos fundamentales. Está pensado como apoyo para estudiantes de enfermería y complemento de su formación.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Fundamentos, grupos farmacológicos, lectura de fichas, cálculos académicos, seguridad y resolución de casos educativos.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Incluye preguntas, cálculos ficticios, actividades y respuestas explicadas.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los cinco bonos están incluidos. Los tres complementos opcionales se venden por separado.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. El precio presentado corresponde al pack de seis tomos y cinco bonos, sin mensualidades.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Consultá el procedimiento y el plazo de entrega antes de realizar el pago.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'No. No otorga título ni habilitación. Tampoco reemplaza práctica supervisada, indicaciones clínicas o protocolos.',
  },
  {
    q: '¿Puedo estudiar a mi ritmo?',
    a: 'Sí. Podés organizar la lectura y las actividades según tu disponibilidad.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Escribí a soportescmdigital@gmail.com.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Micaela Fernández', city: 'Córdoba', minutes: 2 },
  { name: 'Sofía Romero', city: 'Rosario', minutes: 4 },
  { name: 'Brenda Gómez', city: 'Buenos Aires', minutes: 7 },
  { name: 'Julián Díaz', city: 'Mendoza', minutes: 11 },
  { name: 'Paula Medina', city: 'La Plata', minutes: 15 },
  { name: 'Milagros Torres', city: 'Mar del Plata', minutes: 19 },
  { name: 'Lucía Acosta', city: 'Salta', minutes: 24 },
  { name: 'Ayelén Molina', city: 'San Miguel de Tucumán', minutes: 29 },
  { name: 'Nahuel Ríos', city: 'Neuquén', minutes: 33 },
  { name: 'Julieta Herrera', city: 'Santa Fe', minutes: 40 },
]
